import { constants } from '../constants/pacientes.constants';

export const initClientsWorkspace = () => ({
  type: constants.PACIENTES_INIT_WORKSPACE,
  payload: {},
});

export const setClientsWorkspace = (pacientes: any) => ({
  type: constants.PACIENTES_SET_WORKSPACE,
  payload: {
    pacientes,
  },
});

export const setPacientesKeyword = (payload:any) => ({
  type: constants.PACIENTES_SET_KEYWORD,
  payload,
});
export const setFormFilterTiendaState = (payload:any) => ({
  type: constants.PACIENTES_SET_FILTER_TIENDA_STATE,
  payload
});


export const loadPacientesWorkspace = ({
  tiendaId, keyword, page, pageSize, sorter
}: any) => ({
  type: constants.PACIENTES_GET_PACIENTES_REQUEST,
  payload: {
    tiendaId,
    keyword,
    page,
    pageSize,
    sorter,
  },
});

export const createPacienteAction = ({ data, signRgpd, print }: any) => ({
  type: constants.PACIENTES_CREATE_PACIENTE_REQUEST,
  payload: {
    data,
    signRgpd,
    print,
  },
});
export const unsetPacienteDuplicado = () => ({
  type: constants.PACIENTES_UNSET_PACIENTE_DUPLICADO,
});
export const comprobarPacientesduplicados = ({ data, signRgpd, print }: any) => ({
  type: constants.COMPROBAR_PACIENTE_DUPLICADO_REQUEST,
  payload: {
    data,
    signRgpd,
    print,
  },
});

export const updatePacienteAction = (payload: any) => ({
  type: constants.PACIENTES_UPDATE_PACIENTE_REQUEST,
  payload,
});
export const getPaciente = ({ tiendaId, pacienteId }: any) => ({
  type: constants.PACIENTES_GET_PACIENTE_REQUEST,
  payload: { tiendaId, pacienteId },
});

export const getPacientesProfesiones = () => ({
  type: constants.PACIENTES_GET_PACIENTES_PROFESIONES,
  payload: {},
});

export const getPacientesTiendas = () => ({
  type: constants.PACIENTES_GET_PACIENTES_TIENDAS,
  payload: {},
});

export const getPacientesGrupos = () => ({
  type: constants.PACIENTES_GET_PACIENTES_GROUPS,
  payload: {},
});

export const getPacientesIdentificadores = () => ({
  type: constants.PACIENTES_GET_IDENTIFICADORES,
  payload: {},
});

export const getPacienteRGPD = ({ pacienteId }: any) => ({
  type: constants.PACIENTES_GET_PACIENTE_RGPD_REQUEST,
  payload: {
    pacienteId,
  },
});

export const setPacienteRGPDConditions = ({ condiciones, condicionesAdicionales }: any) => ({
  type: constants.PACIENTES_SET_PACIENTE_RGPD_CONDITIONS,
  payload: {
    condiciones,
    condicionesAdicionales,
  },
});

export const setPacienteRGPDCondition = ({ identificador, valor }: any) => ({
  type: constants.PACIENTES_SET_PACIENTE_RGPD_CONDITION,
  payload: { identificador, valor },
});

export const savePacienteRGPD = ({
  pacienteId, firma,
}: any) => ({
  type: constants.PACIENTES_SAVE_PACIENTE_RGPD_REQUEST,
  payload: {
    pacienteId,
    firma,
  },
});

export const getPacienteNotas = ({ pacienteId }: any) => ({
  type: constants.PACIENTES_GET_PACIENTE_NOTAS_REQUEST,
  payload: {
    pacienteId,
  },
});

export const setPacienteNotas = ({ pacienteId, texto }: any) => ({
  type: constants.PACIENTES_SET_PACIENTE_NOTAS_REQUEST,
  payload: {
    pacienteId,
    texto,
  },
});

export const getPacienteInsurances = ({ pacienteId }: any) => ({
  type: constants.PACIENTES_GET_PACIENTE_INSURANCES_REQUEST,
  payload: {
    pacienteId,
  },
});

export const createFichaOptometricaAction = (payload: any) => ({
  type: constants.PACIENTES_CREATE_FICHA_OPTOMETRICA_REQUEST,
  payload,
});

export const updateFichaOptometricaAction = (payload: any) => ({
  type: constants.PACIENTES_UPDATE_FICHA_OPTOMETRICA_REQUEST,
  payload,
});

export const getFichaOptometrica = ({ tiendaId, pacienteId }: any) => ({
  type: constants.PACIENTES_GET_FICHA_OPTOMETRICA_REQUEST,
  payload: { tiendaId, pacienteId },
});

export const getPacientesPaises = () => ({
  type: constants.PACIENTES_GET_PACIENTES_PAISES,
  payload: {},
});

export const getPacientesProvincias = ({ codigoPais }: any) => ({
  type: constants.PACIENTES_GET_PACIENTES_PROVINCIAS,
  payload: { codigoPais },
});

export const getPacientesMutuas = () => ({
  type: constants.PACIENTES_GET_PACIENTES_MUTUAS,
  payload: {},
});

export const getPacientesCamposPersonalizados = ({ create }: any) => ({
  type: constants.PACIENTES_GET_PACIENTE_CAMPOS_PERSONALIZADOS,
  payload: { create },
});

export const getPacientesCamposDinamicos = ({ create }: any) => ({
  type: constants.PACIENTES_GET_PACIENTE_CAMPOS_DINAMICOS,
  payload: { create },
});

export const setPacientesCamposDinamicos = ({ campo_id, valor }: any) => ({
  type: constants.PACIENTES_SET_PACIENTE_CAMPOS_DINAMICOS,
  payload: { campo_id, valor },
});

export const getPacienteUltEncargo = ({ pacienteId }: any) => ({
  type: constants.PACIENTES_GET_PACIENTE_ENCARGO_REQUEST,
  payload: { pacienteId },
});

export const getActivity = (pacienteId: any) => ({
  type: constants.GET_ACTIVITY_DATA_REQUEST,
  payload: { pacienteId },
});
export const getNextActivity = (index: any) => ({
  type: constants.GET_ACTIVITY_NEXT_DATA_REQUEST,
  payload: { index },
});
export const openPacienteUrlAwsRgpd = (pacienteId: any) => ({
  type: constants.PACIENTES_OPEN_PACIENTE_URL_AWS_RGPD_REQUEST,
  payload: { pacienteId },
});
export const downloadPacienteUrlAwsRgpd = (pacienteId: any) => ({
  type: constants.PACIENTES_DOWNLOAD_PACIENTE_URL_AWS_RGPD_REQUEST,
  payload: { pacienteId },
});
export const openPacienteUrlRgpd = (pacienteId: any) => ({
  type: constants.PACIENTES_OPEN_PACIENTE_URL_RGPD_REQUEST,
  payload: { pacienteId },
});
export const downloadPacienteUrlRgpd = (pacienteId: any) => ({
  type: constants.PACIENTES_DOWNLOAD_PACIENTE_URL_RGPD_REQUEST,
  payload: { pacienteId },
});
export const getPhotoPaciente = (pacienteId: any) => ({
  type: constants.GET_PHOTO_PACIENTE_REQUEST,
  payload: { pacienteId },
});

